module.exports = __webpack_public_path__ + "img/奖品-返现卡.ceb3ad12.png";